import { gql } from "@apollo/client";

export const getTracksListQuery = gql`
    query getTracksList($page: Int = 0, $limit: Int = 100000, $orderBy: TrackOrderByInput!, $where: TrackWhereInput!) {
        listTracks(page: $page, elementsPerPage: $limit, orderBy: $orderBy, where: $where) {
            posts {
                id
                title
                title_ar
                track_num
                downloadUri
                originalTrackId
                isrc
                trackFile {
                    id
                    duration
                }
                secondary_artists {
                    id
                    name
                }
                releaseTracks {
                    id
                    releaseId
                }
                artist {
                    id
                    name
                }
                trackFormat {
                    id
                    displayName
                }
                image {
                    id
                    downloadThumbnail
                }
            }
            meta {
                resultCount
                nodeCount
                currentPage
                totalPages
            }
        }
    }
`;

export const getTrackQuery = gql`
    query getTrack($where: TrackWhereUniqueInput!) {
        track(where: $where) {
            custom_id
            id
            isrc_other
            isrc
            iswc
            title
            title_ar
            track_num
            downloadUri
            trackContributorRoles {
                roleId
                role {
                    id
                    name
                }
                contributors {
                    id
                    name
                    name_ar
                    appleId
                }
            }
            royalty {
                id
                master
                mechanical_performance
                synchronization
                neighboring
            }
            image {
                id
                downloadUri
                downloadThumbnail
            }
            videoClips {
                video {
                    id
                    name
                    track {
                        id
                        artist {
                            id
                            name
                        }
                        image {
                            id
                            downloadThumbnail
                        }
                    }
                    release {
                        id
                        image {
                            id
                            downloadThumbnail
                        }
                    }
                    image {
                        id
                        downloadThumbnail
                    }
                }
                downloadUri
            }
            trackFormat {
                id
                displayName
            }
            originalTrackId
            videos {
                id
                isrc
                name
                downloadUri
                type {
                    id
                    name
                }
                track {
                    id
                    artist {
                        id
                        name
                    }
                    image {
                        id
                        downloadThumbnail
                    }
                }
                release {
                    id
                    image {
                        id
                        downloadThumbnail
                    }
                }
                image {
                    id
                    downloadThumbnail
                    downloadUri
                }
                imageId
                thumbnail {
                    id
                    downloadUri
                }
                thumbnailId
            }
            secondary_artists {
                id
                name
            }
            artist {
                id
                name
            }
            trackFile {
                id
                duration
            }
            recordings {
                id
                name
                downloadUri
                trackFile {
                    id
                    duration
                }
            }
            documents {
                id
                name
                downloadUri
            }
            lyric_files {
                id
                downloadUri
                name
            }
            releaseTracks {
                id
                release {
                    id
                    releaseTracks {
                        id
                        track {
                            id
                            isrc
                            title
                            artist {
                                id
                                name
                            }
                            originalTrackId
                        }
                    }
                }
            }
        }
    }
`;

export const getTrackShareLinkQuery = gql`
    query getTrackShareLink($id: Int!) {
        shareLinkTrack(track_id: $id)
    }
`;

export const getTrackBulkUpdateStatusQuery = gql`
    query getTrackBulkUpdateStatus($jobId: String!) {
        getTrackBulkUpdateStatus(jobId: $jobId) {
            id
            status
            progress
            result {
                message
                successRowsNumber
                failedRowsNumber
                errors {
                    row
                    col
                    error
                }
            }
        }
    }
`;
